import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyCrkM6UPB2PQ5q_tEKWxPxpuHz9jPU3YTI",
    authDomain: "marketplace-7c65e.firebaseapp.com",
    databaseURL: "https://marketplace-7c65e-default-rtdb.firebaseio.com",
    projectId: "marketplace-7c65e",
    storageBucket: "marketplace-7c65e.firebasestorage.app",
    messagingSenderId: "816436733736",
    appId: "1:816436733736:web:fb1c063112f1c1172fd21d",
    measurementId: "G-4MF5XCBM0M"
};

import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize App Check (Shield against bots)
if (typeof window !== 'undefined') {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    if (isLocalhost) {
        // @ts-ignore
        window.FIREBASE_APPCHECK_DEBUG_TOKEN = import.meta.env.VITE_APP_CHECK_DEBUG_TOKEN || true;
    }

    try {
        // 🛡️ App Check: Prevent redundant initializations and catch rate limits
        if (typeof window !== 'undefined' && !(window as any)._appCheckInitialized) {
            // Force debug token in development if the build-time env var is missing
            if (isLocalhost && !(window as any).FIREBASE_APPCHECK_DEBUG_TOKEN) {
                (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
                console.log("%cApp Check Debug Mode: ON", "color: #fbbf24; font-weight: bold; font-size: 14px;");
                console.log("Eğer 403 almaya devam ederseniz, konsolun başında çıkan 'App Check debug token'ı kopyalayıp Firebase Console > App Check > Apps > [App Adı] > Debug Tokens kısmına ekleyin.");
            }

            initializeAppCheck(app, {
                provider: new ReCaptchaEnterpriseProvider('6LcWnl4sAAAAAPbm1g9W9tsbKjVCc2pI4hqoZoOL'),
                isTokenAutoRefreshEnabled: true
            });
            (window as any)._appCheckInitialized = true;

            console.log("%cApp Check Initialized", "color: #10b981; font-weight: bold;");
        }
    } catch (err: any) {
        if (err.message?.includes('429')) {
            console.warn("App Check rate limited (429). This is common during rapid development and can usually be ignored.");
        } else {
            console.warn("App Check failed to initialize:", err);
        }
    }
}
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

// Safer Messaging initialization
export let messaging: any = null;

if (typeof window !== 'undefined') {
    isSupported().then(supported => {
        if (supported) {
            messaging = getMessaging(app);
        }
    }).catch(err => {
        console.warn("Messaging check failed:", err);
    });
}

export default app;
